var map = {
	"./icon-accessory-active.png": "6094",
	"./icon-accessory.png": "5779",
	"./icon-add-5.png": "27be",
	"./icon-add.png": "3737",
	"./icon-check-no.png": "c34f",
	"./icon-check-yes.png": "b7e0",
	"./icon-checkbox-selected.png": "5d60",
	"./icon-custom-pattern.png": "ad74",
	"./icon-del-2.png": "6ebf",
	"./icon-del.png": "39fa",
	"./icon-del2.png": "01d8",
	"./icon-doc.png": "3450",
	"./icon-edit-red.png": "d827",
	"./icon-label-active.png": "33a3",
	"./icon-label.png": "ef18",
	"./icon-lesson-active.png": "b665",
	"./icon-lesson.png": "7970",
	"./icon-manuscript-active.png": "666d",
	"./icon-manuscript.png": "f519",
	"./icon-material-active.png": "d3a8",
	"./icon-material.png": "32cb",
	"./icon-other-active.png": "5db9",
	"./icon-other.png": "b780",
	"./icon-package-active.png": "00d7",
	"./icon-package.png": "50d8",
	"./icon-pattern-active.png": "cecd",
	"./icon-pattern.png": "abcc",
	"./icon-platform-pattern.png": "dfa6",
	"./icon-price-active.png": "62a8",
	"./icon-price.png": "5ac7",
	"./icon-self-pattern.png": "44d0",
	"./icon-tech-active.png": "7e00",
	"./icon-tech.png": "4418",
	"./icon-trademark-active.png": "0481",
	"./icon-trademark.png": "4ae0",
	"./icon-upload-black.png": "883d",
	"./icon-upload-pink.png": "e3ff",
	"./icon-upload-white.png": "b53d",
	"./icon-xiuhua-active.png": "3139",
	"./icon-xiuhua.png": "d5ba",
	"./icon-yinhua-active.png": "1704",
	"./icon-yinhua.png": "8d66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "48b5";